import { Button, Card, Col, Flex, Form, Input, Row, SelectProps, Space } from "antd";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { useTranslation } from "react-i18next";
import { RuleObject } from "antd/es/form";
import { ActionService } from "../../services/ActionService";
import { mdlActionTemplateSendMailRequest } from "../../models/service-models/action/ActionTemplateSendMailRequest";
import _ from "lodash";
import { mdlSpoMailSendRequest } from "../../models/service-models/action/SpoMailSendRequest";
import { useEffect } from "react";
import { mdlServiceResponse } from "../../models/service-models/common/ServiceResponse";
import { mdlBaseDataResponse } from "../../models/service-models/common/BaseDataResponse";
import { mdlSpoMailPreviewItem } from "../../models/domain/value-objects/SpoMailPreviewItem";


export type ActionMailProps = {
    callback?: Function;
    spoId?: string;
    onClose?: Function;
    loading?: boolean;
    previewResponse?: mdlServiceResponse<mdlBaseDataResponse<mdlSpoMailPreviewItem>>
}

const ActionMail = (props: ActionMailProps) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const bccValues: SelectProps['options'] = [];

    useEffect(() => {

    }, [props.previewResponse])



    const { mutateAsync: sendMail, isLoading: mutateLoading, data: mutateData } = useMutation(
        (data: mdlSpoMailSendRequest) => ActionService.SendMail(data),
        {
            onMutate(variables) {
                variables.spoId = props.spoId!;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body && data.body.isSuccessful) {
                    form.resetFields();
                    toast.success(t("common.success"));
                    props.callback && props.callback();
                } else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const validateEmail = (_: RuleObject, value: string) => {
        if (value != null && value.length > 0) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(value)) {
                return Promise.reject(new Error(`${value} ${t("common.isNotAValidMailAddress")}`));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    return (
        <Card loading={props.loading}>
            <Form
                form={form}
                initialValues={{ subject: props.previewResponse?.body?.data?.subject, spoType: props.previewResponse?.body?.data?.spoType }}
                name="send-action-mail-form"
                layout="vertical"
                onFinish={async (values) => await sendMail(values)}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={8}>
                        <Form.Item<mdlSpoMailSendRequest>
                            label={t("action.template.to")}
                            name={'to'}
                            rules={[
                                { required: true, message: t("common.required") },
                                {
                                    validator: validateEmail,
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item<mdlSpoMailSendRequest>
                            label={t("action.template.subject")}
                            name={'subject'}
                            rules={[
                                { required: true, message: t("common.required") },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={8}>
                        <Form.Item<mdlActionTemplateSendMailRequest>
                            label={t("action.template.spoType")}
                            name={'spoType'}
                        >
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>

                {
                    props.previewResponse?.body?.data?.previewHTML
                    &&
                    <Flex vertical>
                        <label>{t("action.template.content")}</label>
                        <div dangerouslySetInnerHTML={{ __html: props.previewResponse?.body?.data?.previewHTML }} />
                    </Flex>

                }


                <Row style={{ marginTop: "25px" }} justify={"end"}>
                    <Form.Item>
                        <Flex align={"center"} justify="flex-end">
                            <Space>
                                <Button type="primary" htmlType="submit">{t("common.send")}</Button>
                                <Button type="primary" onClick={() => props.onClose && props.onClose()} danger htmlType="button">{t("common.close")}</Button>
                            </Space>
                        </Flex>

                    </Form.Item>
                </Row>
            </Form>
        </Card>
    )
}

export default ActionMail;